export default {
  install(Vue) {
    Vue.prototype.$formatDateTime = function (date) {
      if (!date) return ''
      if (date.startsWith('0001')) return ''

      const d = new Date(date)
      if (isNaN(d)) return ''

      const dia = String(d.getDate()).padStart(2, '0')
      const mes = String(d.getMonth() + 1).padStart(2, '0')
      const año = String(d.getFullYear()).slice(-2)

      let horas = d.getHours()
      const minutos = String(d.getMinutes()).padStart(2, '0')
      //const segundos = String(d.getSeconds()).padStart(2, '0')

      const ampm = horas >= 12 ? 'pm' : 'am'
      horas = horas % 12
      horas = horas ? horas : 12 // 0 => 12
      horas = String(horas).padStart(2, '0')

      return `${dia}/${mes}/${año} ${horas}:${minutos} ${ampm}`
    }

    // Filtro para usar directo en template
    Vue.filter('formatDateTime', function (date) {
      return Vue.prototype.$formatDateTime(date)
    })
  }
}

